var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCubeMarketplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 32.3182V32.1561V16.3332C8.66699 15.7026 9.00711 15.121 9.55673 14.8119L9.58842 14.794L24.2208 6.56329L24.3321 6.50074C24.747 6.26733 25.2537 6.26733 25.6686 6.50074L40.5384 14.8651C41.0297 15.1414 41.3337 15.6611 41.3337 16.2247V16.3332V32.1561V32.3182C41.3337 32.895 41.0286 33.4287 40.5319 33.7214L25.7741 42.4187C25.2966 42.7001 24.7041 42.7001 24.2265 42.4187L9.46869 33.7214C8.97192 33.4287 8.66699 32.895 8.66699 32.3182Z",
    stroke: "#0D0D0D",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42.875V24.5",
    stroke: "#0D0D0D",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 24.5L8.66699 15.3125",
    stroke: "#0D0D0D",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3333 15.3125L25 24.5",
    stroke: "#0D0D0D",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeMarketplace);
export default __webpack_public_path__ + "static/media/cubeMarketplace.225204ec0cf09dafa887faa31171e05c.svg";
export { ForwardRef as ReactComponent };